import * as React from 'react'
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { useEffect, useState } from 'react'

interface ISnackBarConfig {
    severity: 'success' | 'warning' | 'info' | 'error'
    text: string
}

interface ISnackBar {
    show: (options: ISnackBarConfig) => void
}

export const snackbar: ISnackBar = {
    show: null
}

function SnackbarService() {
    const [open, setOpen] = useState(false)
    const [config, setConfig] = useState<ISnackBarConfig>(null)

    useEffect(() => {
        snackbar.show = ({ severity, text }) => {
            setConfig({ severity, text })
            setOpen(true)
        }
    }, [])

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
            return
        }
        setOpen(false)
    }

    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            sx={{ maxWidth: 'calc(100% - var(--left-nav-width) - calc(8 * var(--unit)))' }}
            onClose={handleClose}>
            <Alert
                onClose={handleClose}
                severity={config?.severity ?? 'info'}
                variant='filled'
                sx={{ width: '100%' }}>
                <span dangerouslySetInnerHTML={{ __html: (config?.text ?? '').replace(/\n/g, '<br/>') }} />
            </Alert>
        </Snackbar>
    )
}

export default SnackbarService
